import React from "react";

import { Navigate, Outlet, createFileRoute } from "@tanstack/react-router";

import { Queries } from "@/queries/Queries.ts";

const AdminRouteGuard: React.FC = () => {
  const me = Queries.user.useMe({});
  switch (me.userType) {
    case "admin":
      return <Outlet />;
    default:
      return <Navigate to="/" />;
  }
};

export const Route = createFileRoute("/admin")({
  component: AdminRouteGuard,
});
